import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'

// Safari mobile fix - ensure DOM is ready
function initApp() {
  const rootElement = document.getElementById('root');
  if (rootElement) {
    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  } else {
    console.error('Root element not found');
  }
}

// Ensure DOM is ready before mounting React
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp);
} else {
  initApp();
}
